import usePendingState from '../../Hooks/usePendingState';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../Contexts/NotificationContext';
import Loading from '../Loading';

function FormInvite({ closeModal }) {
    const { setNotification } = useNotification();
    const [userData, setUserData] = useState({
        nome: '',
        email: '',
    });

    const [userErrorData, setUserErrorData] = useState({
        nome: [],
        email: [],
    });

    const [formLoading, setFormLoading, formPendingRef] = usePendingState();
    const [error, setError] = useState('');

    const navigate = useNavigate();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setUserData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formPendingRef.current) return;
        setFormLoading(true);

        try {
            const response = await fetch(`${baseUrl}/manager/internos/convidar`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify(userData),
            });
            if (response.ok) {
                const data = await response.json();

                setNotification({
                    type: 'success',
                    message: data.message,
                    show: true,
                });

                navigate('/manager/usuarios-internos');

                closeModal();
            } else {
                if (response.status === 422) {
                    const errors = await response.json();

                    setUserErrorData(errors);
                } else if (response.status === 500) {
                    const errors = await response.json();

                    setError(errors.error);
                }
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setFormLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center z-[99999]">
            <div className="absolute inset-0 bg-black bg-opacity-50" onClick={closeModal}></div>
            <div className="animate-fade-in-down [animation-duration:_0.1s] rounded-sm border border-stroke bg-white w-full max-w-xl px-8 py-10 text-left shadow-md relative">
                <button type="button" className="absolute top-2 right-5 opacity-40 text-xl font-bold rotate-45" onClick={closeModal}>
                    +
                </button>

                <h1 className="font-bold text-xl mb-5">Convidar novo usuário</h1>
                <form onSubmit={handleSubmit} className="max-w-5xl pb-4">
                    <div className="mb-6 2xl:mb-10">
                        <div className="mb-3 flex gap-5 flex-col lg:flex-row">
                            <div className="w-full">
                                <label className="block text-sm mb-1">Nome:</label>
                                <input
                                    type="text"
                                    name="nome"
                                    value={userData.nome}
                                    onClick={() => setUserErrorData((prevData) => ({ ...prevData, nome: [] }))}
                                    onChange={handleChange}
                                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {userErrorData.nome && userErrorData.nome[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {userErrorData.nome[0]}{' '}
                                        <span
                                            onClick={() => setUserErrorData((prevData) => ({ ...prevData, nome: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="mb-3 flex gap-5 flex-col lg:flex-row">
                            <div className="w-full">
                                <label className="block text-sm mb-1">E-mail:</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={userData.email}
                                    onClick={() => setUserErrorData((prevData) => ({ ...prevData, email: [] }))}
                                    onChange={handleChange}
                                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {userErrorData.email && userErrorData.email[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {userErrorData.email[0]}{' '}
                                        <span
                                            onClick={() => setUserErrorData((prevData) => ({ ...prevData, email: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                                {error && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {error}{' '}
                                        <span onClick={() => setError(null)} className="rotate-45 -my-2 p-2 cursor-pointer">
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="">
                            A senha padrão é <span className="text-secondary font-bold">Padrao@Rometal02</span>
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={formLoading}
                        aria-busy={formLoading}
                        className="w-full bg-secondary text-white py-2 px-4 rounded-md hover:bg-opacity-80 disabled:bg-opacity-80 disabled:cursor-not-allowed"
                    >
                        {!formLoading ? 'Enviar' : <Loading />}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default FormInvite;
